import {memo} from 'react';

import OLView from 'ol/View';

import {useMap} from './Map';

const View = options => {
    return useMap(
        map => {
            map.setView(new OLView(options));
        },
        [options],
    );
};

export default memo(View);
